// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608250302/js/" + chunkId + "." + {"44":"203ecc45","225":"ce998bfa","481":"2522ba96","486":"a2548938","770":"dd05a1dc"}[chunkId] + ".0.5378761179108423.chunk.js";
};